"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogHeaderImage = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeaderImage"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var SuccessModal = function SuccessModal(_ref) {
  var header = _ref.header,
      footer = _ref.footer;
  return _react.default.createElement(_UIModal.default, {
    centered: true,
    use: "success",
    width: 600
  }, _react.default.createElement(_UIDialogHeaderImage.default, {
    offsetBottom: 23,
    offsetTop: 99
  }, _react.default.createElement(_UIIllustration.default, {
    name: "success",
    width: 118
  })), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, null, header)), _react.default.createElement(_UIDialogBody.default, null), _react.default.createElement(_UIDialogFooter.default, null, footer));
};

SuccessModal.propTypes = {
  header: _propTypes.default.node,
  footer: _propTypes.default.node
};
var _default = SuccessModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/SuccessModal.js
// module id = 470
// module chunks = 5 6